import React, { Component } from 'react';

import { REST_API_URL } from "../../Utils/Global";

import ExportCSV from '../Helper/Grid/ExportCSV';
import Grid from '../Helper/Grid';
import GridFilter from '../Helper/GridFilter';

import Client from '../Entity/Client';
import Echange from '../Entity/Echange';
import Evenement from '../Entity/Evenement';

/**
* Class ActiviteClientList
* ActiviteClientList view component
**/
class ActiviteClientList extends Component {

  /**
  * render
  * Rendering component function : display the view
  **/
  render() {
    const objectClassClient = Client;
    const objectClassEvenement = Evenement;
    const objectClassEchange = Echange;

    // Filter list
    const filters = this.getFilters();

    // Rendering the view
		return (
      <div className="searchContainer">
        <h2>Activité client</h2>
        <GridFilter title="Filtrer les clients" objectClass={objectClassClient.getClassName()} filters={filters} parent={this} formattedFilters={true} />

        <Grid title="Occupations" ref="gridClient" path="activitesclient" objectPath="activitesclient" objectClass={objectClassClient}
          ignoreAdd={true} withoutActions={true} height="200px" hidden={false} />
        <ExportCSV parent={this} gridRef="Client" />

        <Grid title="Evénements" ref="gridEvenement" path="activitesclient/evenements" objectPath="activitesclient/evenements" objectClass={objectClassEvenement}
          ignoreAdd={true} withoutActions={true} height="200px" hidden={false} />
        <ExportCSV parent={this} gridRef="Evenement" fields={["Client", "Libellé", "Date", "Type", "N° Occupation"]} />

        <Grid title="Echanges" ref="gridEchange" path="activitesclient/echanges" objectPath="activitesclient/echanges" objectClass={objectClassEchange}
          ignoreAdd={true} withoutActions={true} height="200px" hidden={false} />
        <ExportCSV parent={this} gridRef="Echange" fields={["Client", "Libellé", "Date", "Type", "N° Occupation"]} />
      </div>
		);
	}

  /**
  * applyFilter
  * Filters the grid
  **/
  applyFilter(fieldName, value) {
    const gridClient = this.refs.gridClient;
    gridClient.applyFilter(fieldName, value);

    const gridEvenement = this.refs.gridEvenement;
    gridEvenement.applyFilter(fieldName, value);

    const gridEchange = this.refs.gridEchange;
    gridEchange.applyFilter(fieldName, value);
  }

  /**
  * clearFilters
  * Clear the filters
  **/
  clearFilters() {
    const gridClient = this.refs.gridClient;
    gridClient.clearFilters();

    const gridEvenement = this.refs.gridEvenement;
    gridEvenement.clearFilters();

    const gridEchange = this.refs.gridEchange;
    gridEchange.clearFilters();
  }

  /**
  * getFilters
  * Returns the filters
  **/
  getFilters() {
    return [{
      title: "Client",
      type: "combo",
      name: "idClient",
      optionValueKey: "idClient",
      optionLabelKey: "libelle",
      searchable: true,
      url: REST_API_URL + "/clients/",
      size: 4,
      rowIdx: 1
    },{
      title: "Occupation",
      type: "combo",
      name: "idContrat",
      optionValueKey: "idContrat",
      optionLabelKey: "numeroStr",
      searchable: true,
      url: REST_API_URL + "/contrats/",
      rowIdx: 1
    },{
      title: "Numéro de parcelle",
      type: "combo",
      name: "idParcelle",
      optionValueKey: "gid",
      optionLabelKey: "idu",
      searchable: true,
      url: REST_API_URL + "/parcellegestionpag/",
      rowIdx: 1
    }];
  }

}
export default ActiviteClientList;



// WEBPACK FOOTER //
// ./src/views/Search/ActiviteClientList.js